import React, { useState } from 'react'
import { Form, Button, Modal, Card, Spinner } from 'react-bootstrap'
import PasswordSection from './password-section'
import { useAuth } from '../../auth/auth-context'
import useFetch from '../../_fetch'
import { currencies } from '../../_utils'

export default function UserSettings() {
    const { user, login } = useAuth()
    const { doFetch } = useFetch()
    const currency = user?.settings?.currency

    const [formData, setFormData] = useState({ currency })
    const [submitting, setSubmitting] = useState(false)

    const [successModalMsg, setSuccessModalMsg] = useState('')
    const [errorModalMsg, setErrorModalMsg] = useState('')

    const handleInputChange = (e: React.ChangeEvent<any>) => {
        const { name, value } = e.target
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }))
    }

    const onSettingsSubmit = async (e:React.FormEvent) => {
        e.preventDefault()
        setSubmitting(true)

        try {
            const res = await doFetch('/update-settings', {
                currency: formData.currency
            })
            
            if(res.status >= 400) throw await res.text()

            const {token} = await res.json()

            login(token)
            setSuccessModalMsg('Settings updated successfully')
        } catch (error) {
            setErrorModalMsg('Failed to update settings')
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <div className="mt-3 mx-3">
            <h2>User Settings</h2>
            <hr />
            <Card className="mb-3">
                <Card.Body>
                    <h3>User Information</h3>
                    <p><strong>Username:</strong> {user?.username}</p>
                    <p><strong>User Type:</strong> {user?.kind}</p>
                </Card.Body>
            </Card>

            <Card className="mb-3">
                <Card.Body>
                    <h3>Preferences</h3>
                    <Form onSubmit={onSettingsSubmit}>
                        <Form.Group controlId="formCurrency" className="col-sm-6">
                            <Form.Label>Currency</Form.Label>
                            <Form.Control
                                as="select"
                                name="currency"
                                value={formData.currency}
                                onChange={handleInputChange}
                            >
                                {currencies.map((currency) => (
                                    <option key={currency} value={currency}>
                                        {currency}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>

                        <Button variant="primary" type="submit" className="mt-2" disabled={submitting}>
                            {submitting ? (
                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                            ) : (
                                'Save Settings'
                            )}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>

            <PasswordSection setSuccessModalMsg={setSuccessModalMsg} />

            <Modal show={!!successModalMsg} onHide={() => setSuccessModalMsg('')}>
                <Modal.Header closeButton className="bg-success text-white">
                    <Modal.Title>Success</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{successModalMsg}</p>
                </Modal.Body>
            </Modal>

            <Modal show={!!errorModalMsg} onHide={() => setErrorModalMsg('')}>
                <Modal.Header closeButton className="bg-danger text-white">
                    <Modal.Title>Error</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{errorModalMsg}</p>
                </Modal.Body>
            </Modal>
        </div>
    )
}
